export default "__VITE_ASSET__DotFJzGA__"